import React, { FC, useEffect } from 'react'

import { InjectedFormProps, reduxForm, SubmissionError } from 'redux-form'

import CalculatorSchema from '~/schemas/listing/calculator'
import EmpriseGroup from '~/services/EmpriseGroup'
import { asyncValidate } from '~/utils/asyncValidate'
import { createSubmit } from '~/utils/createSubmit'

import ProductCalculateFormTemplate from './templates/ProductCalculateForm/ProductCalculateFormTemplate'

interface ProductCalculateFormProps {
  setRepayment: (payment: any) => void
  loading?: boolean
  price: number
}

const ProductCalculateForm: FC<
  InjectedFormProps & ProductCalculateFormProps
> = ({ handleSubmit, submitting, initialize, loading, price }) => {
  useEffect(() => {
    const values = {
      loan_amount: price,
      interest_rate: '7.98',
      loan_term: '7',
      payment_freq: 'weekly'
    }
    initialize(values)
  }, [price])

  return (
    <form noValidate onSubmit={createSubmit({ handleSubmit })}>
      <ProductCalculateFormTemplate loading={loading} submitting={submitting} />
    </form>
  )
}

interface CalculatorType {
  loan_amount: string
  interest_rate: string
  loan_term: string
  payment_freq: string
}

const withForm = reduxForm<CalculatorType, ProductCalculateFormProps, any>({
  form: 'Product_Calculate_Form',
  destroyOnUnmount: false,
  asyncValidate: asyncValidate(CalculatorSchema),
  onSubmit: async (values, _dispatch) => {
    try {
      const { data } = await EmpriseGroup.repaymentCalculations({ ...values })
      return {
        pay: data,
        frequency: values.payment_freq
      }
    } catch (error) {
      throw new SubmissionError((error as any)?.errors)
    }
  },
  onSubmitSuccess: (data, _dispatch, { setRepayment }) => {
    setRepayment(data)
  }
})

// @ts-ignore
export default withForm(ProductCalculateForm)
